import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=1253a4ae&scoped=true&"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts&"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=1253a4ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253a4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VSpacer})
